(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd-faq"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-jd-faq]');
    if (!section) return;

    var items = section.querySelectorAll('.jd-faq__item');

    items.forEach(function (item) {
      var button = item.querySelector('.jd-faq__question');
      var panel = item.querySelector('.jd-faq__panel');

      button.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.jd-faq__question').setAttribute('aria-expanded', 'false');
          other.querySelector('.jd-faq__panel').setAttribute('aria-hidden', 'true');
        });

        item.classList.toggle('is-open', !wasOpen);
        button.setAttribute('aria-expanded', String(!wasOpen));
        panel.setAttribute('aria-hidden', String(wasOpen));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-jd-header]').forEach(function (header) {
      var details = header.querySelector('.jd-header__disclosure');
      var summary = details && details.querySelector('summary');

      if (details && summary) {
        var syncExpanded = function () {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        };

        syncExpanded();
        details.addEventListener('toggle', syncExpanded);

        details.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () {
            details.open = false;
          });
        });

        document.addEventListener('click', function (event) {
          if (details.open && !details.contains(event.target)) {
            details.open = false;
          }
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && details.open) {
            details.open = false;
            summary.focus();
          }
        });
      }
    });

    document.querySelectorAll('.jd-header__cta').forEach(function (cta) {
      cta.addEventListener('click', function (event) {
        var href = cta.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        event.preventDefault();

        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd-notify"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-jd-notify]');
    if (!section) return;

    var cards = section.querySelectorAll('.jd-notify__card');
    if (!cards.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function update() {
      ticking = false;
      if (reduceMotion.matches) return;

      var vh = window.innerHeight;

      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        // 0 while the card is centered at the bottom of the viewport,
        // 1 once it has scrolled up past the top — a per-card scroll
        // progress, not a single value for the whole section.
        var progress = 1 - (rect.top + rect.height / 2) / vh;
        progress = Math.max(-1, Math.min(1, progress));

        // The max vector (--jd-pdx/--jd-pdy/--jd-pdr) is read from
        // CSS, not JS, so it can differ by breakpoint (desktop uses
        // a larger amplitude) without any script branching.
        var style = getComputedStyle(card);
        var dx = parseFloat(style.getPropertyValue('--jd-pdx')) || 0;
        var dy = parseFloat(style.getPropertyValue('--jd-pdy')) || 0;
        var dr = parseFloat(style.getPropertyValue('--jd-pdr')) || 0;

        card.style.setProperty('--jd-px', (progress * dx).toFixed(2) + 'px');
        card.style.setProperty('--jd-py', (progress * dy).toFixed(2) + 'px');
        card.style.setProperty('--jd-pr', (progress * dr).toFixed(2) + 'deg');
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (!reduceMotion.matches) {
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
